/**
 * Lightweight in-memory store for a file that should be auto-loaded when the
 * destination tool page mounts. The homepage sets a file here and immediately
 * navigates; the tool page reads and clears it on mount.
 *
 * Using a module-level variable (not React state / context) keeps the handoff
 * completely outside the render cycle and avoids any serialisation step —
 * the File object is passed by reference, never stringified.
 */

let _pendingFile: File | null = null;

export function setPendingFile(file: File): void {
  _pendingFile = file;
}

export function takePendingFile(): File | null {
  const f = _pendingFile;
  _pendingFile = null;
  return f;
}
